exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ivu-message .ivu-message-notice-content-text[data-v-7ba5bd90] {\n  font-size: 14px;\n}\n.ivu-modal-mask[data-v-7ba5bd90] {\n  z-index: 1002 !important;\n}\n.ivu-modal-wrap[data-v-7ba5bd90] {\n  z-index: 1003 !important;\n}\n", ""]);

// exports
